import { inputWithOptionsDriverFactory as coreAutocompleteDriverFactory } from '../internal/WixUiCoreComponents/components/CoreInputWithOptons/CoreInputWithOptions.driver';
import { errorMessageWrapperDriverFactory } from '../ErrorMessageWrapper/ErrorMessageWrapper.driver';

export const autocompleteDriverFactory = ({ element, eventTrigger }) => {
  const errorMessageWrapperDriver = errorMessageWrapperDriverFactory({
    element,
  });
  return {
    ...coreAutocompleteDriverFactory({
      element: errorMessageWrapperDriver.getRenderElement(),
      eventTrigger,
    }),
  };
};
